export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";